import { Reveal } from "./Reveal";

const REASONS = [
  {
    title: "AI-FIRST THINKING",
    desc: "Modern technology integrated into the creative process.",
  },
  {
    title: "STRATEGY BEFORE EXECUTION",
    desc: "Every creative decision should have a reason.",
  },
  {
    title: "CREATIVE WITHOUT LIMITS",
    desc: "Design and content built to make brands memorable.",
  },
  {
    title: "ONE GROWTH PARTNER",
    desc: "Strategy, content, design, websites and AI under one roof.",
  },
  {
    title: "BUILT FOR WHAT'S NEXT",
    desc: "We build brands for the future, not yesterday's internet.",
  },
];

export const Why = () => (
  <section id="about" data-testid="why-section" className="relative py-28 lg:py-40 bg-black overflow-hidden">
    <div
      aria-hidden="true"
      className="absolute -left-40 top-1/3 w-[500px] h-[500px] bg-[#6D00FF]/8 blur-[180px] rounded-full pointer-events-none"
    />
    <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
      <div className="grid lg:grid-cols-[1fr_1.4fr] gap-14 lg:gap-24">
        <div className="lg:sticky lg:top-32 self-start">
          <Reveal>
            <p className="text-xs font-bold uppercase tracking-[0.28em] text-[#8B2CFF] mb-6">
              The Difference
            </p>
            <h2 className="font-display text-3xl sm:text-5xl font-extrabold uppercase tracking-tight leading-[1.05]">
              Why <span className="text-gradient-purple">BrandZenith?</span>
            </h2>
            <p className="mt-7 text-base text-[#A6A6B0] leading-relaxed max-w-sm">
              Not another agency. A growth partner built for the age of intelligent creativity.
            </p>
          </Reveal>
        </div>

        <div>
          {REASONS.map((r, i) => (
            <Reveal key={r.title} delay={i * 0.06} y={30}>
              <div
                data-testid={`why-item-${i}`}
                className="group border-t border-white/[0.07] py-9 last:border-b grid sm:grid-cols-[64px_1fr] gap-4"
              >
                <span className="font-display text-sm font-bold tracking-[0.2em] text-[#8B2CFF]/60 group-hover:text-[#C43CFF] transition-colors duration-500 pt-1">
                  0{i + 1}
                </span>
                <div>
                  <h3 className="font-display text-lg sm:text-2xl font-extrabold uppercase tracking-tight mb-3 group-hover:translate-x-1 transition-transform duration-500">
                    {r.title}
                  </h3>
                  <p className="text-sm sm:text-base text-[#A6A6B0] leading-relaxed">{r.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
